import { render } from "./FieldGroup__base_wrap.vue?vue&type=template&id=8fef5356&scoped=true"
import script from "./FieldGroup__base_wrap.vue?vue&type=script&lang=js"
export * from "./FieldGroup__base_wrap.vue?vue&type=script&lang=js"

import "./FieldGroup__base_wrap.vue?vue&type=style&index=0&id=8fef5356&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fef5356"]])

export default __exports__